






























import { Vue, Component, Emit } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Occupation, Worker, Patient } from '@/types/user'

@Component
export default class UserSearchForm extends Vue {
  $store!: ExStore
  occupations: Occupation[] = []
  selectedOccupation = ''
  readonly patientOccupation = {
    code: 'patient',
    name: '患者',
    shortName: 'Pt'
  }
  users: (Worker | Patient)[] = []
  searchText = ''

  @Emit('change')
  onChangeText() {
    this.getUsers()
    return this.searchText
  }

  @Emit('update')
  onUpdateUsers() {
    return this.usersWithoutSelf
  }

  @Emit('change-occupation')
  onChangeOccupation() {
    this.getUsers()
    return this.selectedOccupation
  }

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get usersWithoutSelf() {
    return this.users.filter(user => user.id !== this.userInfo.id)
  }

  async beforeCreate() {
    const occupations = await this.$api.user.occupationList()
    this.occupations = [
      { code: '', name: '', shortName: '' },
      this.patientOccupation,
      ...occupations
    ]
  }

  async getUsers() {
    if (!this.selectedOccupation) {
      await this.getAllUsers()
    } else if (this.selectedOccupation === this.patientOccupation.code) {
      await this.getPatients()
    } else {
      await this.getWorkers()
    }
    this.onUpdateUsers()
  }
  async getAllUsers() {
    const query = this.searchText
    const pRes = await this.$api.user.patientList({ query, archived: false })
    const wRes = await this.$api.user.workerList({ query })
    this.users = [...pRes.results, ...wRes.results]
  }
  async getPatients() {
    const query = this.searchText
    const res = await this.$api.user.patientList({ query, archived: false })
    this.users = res.results
  }
  async getWorkers() {
    const query = this.searchText
    const res = await this.$api.user.workerList({
      query,
      occupation: this.selectedOccupation
    })
    this.users = res.results
  }
}
